import { ACTION_TYPE_NAME } from "./actionTypeName";
import { NineKPlusOutlined } from "@mui/icons-material";
import { Grid, Tooltip } from "@mui/material";

import PauseIcon from '@mui/icons-material/Pause'; 
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import whatsappIcon from './../../../assets/Whatsapp.svg'
import instagramIcon from './../../../assets/images/channels/instagram/instagram.png'
import facebookIcon from './../../../assets/facebook-logo.svg'

import workflowStyle from "../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss"
import globalStyles from "../../../assets/styles/global.module.scss";
import templatePreviewStyles from "../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss";

import IconsColor from "../../utility/iconsColor";
import RenderCustomOption from "../../global/autocomplete/renderCustomOption";
import { getTemplateDetailsUsedInNode, isCarouselTemplateActionType, isSendOrderDetailTemplateActionType } from "./utilityFunctions";
import { renderTemplateCategoryChip, TEMPLATE_TYPES } from "../channels/global/whatsapp/templates/utils";
import { checkValidRegex, fontColorForMethod, WHATSAPP_PAYMENT_INFO_SYSTEM_API } from "../../../utils/constants";
import { toCapitalizedCase } from "../../../utils/constants";
import { CHATBOT_CHANNEL_NAME, getChatbotChannelTheme, isFacebookChannel, isInstagramChannel, isWhatsAppChannel } from "../../../pages/ruleBasedInbox/channelConstants";
import { INSTAGRAM_ACTION_TYPES } from "../../../pages/ruleBasedInbox/constants";

export { ACTION_TYPE_NAME };

export const triggerDataTempObject = {
    function_id: 1,
    function_name: "trigger",
    function_type: "message",
    function_media_name: "whatsapp",
    function_triggers: [
        {
            function_trigger_id: 1,
            function_trigger_value: "a specific word or words",
            function_trigger_example_options: [
                {
                    function_trigger_example_option_id: 1,
                    function_trigger_example_option_value: "Hello"
                },
                {
                    function_trigger_example_option_id: 2,
                    function_trigger_example_option_value: "Hii"
                },
                {
                    function_trigger_example_option_id: 3,
                    function_trigger_example_option_value: "Good Morning"
                }
            ]
        },
        {
            function_trigger_id: 2,
            function_trigger_value: "any word",
            function_trigger_example_options: []
        }
    ]
}

export const messageDataTempObject = {
    function_id: 1,
    function_name: "message",
    function_type: "message",
    function_media_name: "whatsapp",
    function_messages: [
        {
            function_message_id: 0,
            function_message_value: ""
        }
    ]
}

export const actionTypeArray = ["ReDeploy", "ReDirect"]; 

export const actionTypeForException = (currentActiveStaticWorkflow) => {

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;

    const isWhatsapp = isWhatsAppChannel(channelName);
    const isInstagram = isInstagramChannel(channelName);
    
    return [
        ...(isWhatsapp ? [{
            userText: "Restart chatbot from the beginning", 
            key: "ReDeploy",
        }] : []), 
        ...(isWhatsapp || isInstagram ? [{
            userText: "Re-Direct user to another step", 
            key: "ReDirect",
        }] : []), 
        ...(isWhatsapp ? [{
            userText: "Ignore error", 
            key: "Do Nothing"
        }] : []), 
    ];
}

export const defaultTargetChatbotStep = {
    target_chatbot_step_id: "", 
    target_chatbot_step_name: "", 
    target_chatbot_step_type: {
        target_chatbot_step_type_id: "", 
        target_chatbot_step_type_name: "",
    },
}

export const defaultChatbotStep = {
    chatbot_step_id: "",
    chatbot_step_name: "",
    chatbot_step_type: {
        chatbot_step_type_id: "",
        chatbot_step_type_name: "",
    },
}

export const emptyPostDeploymentTriggerDataObj = {
    chatbot_post_deployment_trigger_id: "",
    chatbot_post_deployment_trigger_type: {
        chatbot_post_deployment_trigger_type_id: "",
        chatbot_post_deployment_trigger_type_name: "",
    },
    condition_group: {
        condition_type: "static_value_check",
        flag_advanced_condition: false,
        condition_values: [],
    },
    pre_transition_text_message: "",
    chatbot_step: {
        chatbot_step_id: "",
        chatbot_step_name: "",
        chatbot_step_type: {
            chatbot_step_type_id: "",
            chatbot_step_type_name: "",
        }
    },
    action_type: "ReDirect",
}
export const initialNodes = [
    {
        "id": "0",
        "icon": "/static/media/AddInputfield.2c5da85d3d9d59f4eb231cbef67d4e57.svg",
        "type": "trigger",
        "data": {
            "text": "",
            "buttons": [],
            "delayTimeSec": "",
            "flagTimeout": false,
            "timeoutMins": "",
            "buttonLimit": 3
        },
        "position": {
            "x": 50,
            "y": 50
        },
        "measured": {
            "width": 425,
            "height": 206
        }
    }


];
export const chatbotDetails = {
    "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
    "chatbot_name": "Apdu Junagadh",
    "chatbot_type": {
        "chatbot_type_id": "6dcfdb6f-688a-4a4d-8574-640531c0050e",
        "chatbot_type_name": "Workflow"
    },
    "chatbot_status": {
        "chatbot_status_id": "6",
        "chatbot_status_name": "Published"
    },
    "chatbot_channel": {
        "channel_id": "1",
        "channel_name": "WhatsApp"
    },
    gpt_model: [],
    "chatbot_integrated_channel_deployment": [
        {
            "meta_integration_whatsapp_id": 2900,
            "waba_id": "551155088072742",
            "waba_name": "Aapdu Junagadh",
            "meta_integration_whatsapp_phone_number_data": [
                {
                    "meta_integration_whatsapp_phone_number_id": 336,
                    "integrated_channel_id": 39,
                    "phone_number_id": "496839670187993",
                    "verified_name": "Aapdu Junagadh",
                    "code_verification_status": "EXPIRED",
                    "display_phone_number": "+91 63560 12000",
                    "quality_rating": "GREEN",
                    "integrated_channel_flag_active": true,
                    "chatbot_integrated_channel_deployment_id": "ebcfbb8c-858a-4378-80b7-751f7dd91f70"
                }
            ],
            "channel_authoriser_user_data": {
                "channel_authoriser_user_data_id": 4,
                "authoriser_unique_id": "1",
                "authoriser_unique_name": null,
                "authoriser_unique_email": null,
                "channel_group": {
                    "channel_group_id": 1,
                    "channel_group_name": "Meta"
                }
            }
        }
    ],
    "chatbot_version_info": [
        {
            "chatbot_version_id": "469d71b5-f512-4e9e-b673-18959088cecf",
            "chatbot_version_status_id": "6",
            "chatbot_version_status_name": "Published",
            "timestamp": "2025-02-18T02:33:34.000Z",
            "chatbot_step_deployment_trigger_data": [
                {
                    "chatbot_step_deployment_trigger_data_id": "f6df8f59-e419-4fae-9560-cfd3bddf9180",
                    "chatbot_integrated_channel_deployment_id": "ebcfbb8c-858a-4378-80b7-751f7dd91f70",
                    "condition_group": null
                }
            ],
            "chatbot_step_data": [
                {
                    "chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "-735",
                        "chatbot_step_y_axis": "2100"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "d09f7bfa-c5dc-4964-b931-b19a26f4c837",
                            "chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "parent_chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "cb7619d7-bec6-4b86-871a-9d22e57b8322",
                                "condition_group_name": "Match Gujarati Language",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "31"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "44e86cba-cbf9-4c50-84a5-69422e72e959",
                            "chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "f718bd6c-ba98-4139-9e8d-3b33a6b42686",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "363",
                                    "whatsapp_template_name": "enquiry_options_gu_aapdu_junagadh_template_new"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        },
                        {
                            "chatbot_step_action_id": "e5900c78-6ca7-42cc-9c94-6f1fbbe20bc1",
                            "chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "sequence": "2",
                            "action_type": {
                                "action_type_id": "e435a612-5fb7-4641-a09d-9a954a1941d1",
                                "action_type_name": "await_user_message"
                            },
                            "action_data": {}
                        },
                        {
                            "chatbot_step_action_id": "fea5e622-8090-48ec-a228-d6682eef898e",
                            "chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "sequence": "3",
                            "action_type": {
                                "action_type_id": "182e486a-637f-40ed-976b-5c909d9d094c",
                                "action_type_name": "redirect_to_step"
                            },
                            "action_data": {}
                        }
                    ]
                },
                {
                    "chatbot_step_id": "1536b3b4-e4c6-4cea-a428-d63599939ce2",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "270",
                        "chatbot_step_y_axis": "-60"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "c1064a3e-603b-4971-ba5a-d9499722d2dc",
                            "chatbot_step_id": "1536b3b4-e4c6-4cea-a428-d63599939ce2",
                            "parent_chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "467e4825-f3ec-4b3b-b513-ec9618551748",
                                "condition_group_name": "Match \"Advertisement Package\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "33"



                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "aff1677c-6375-4c82-9e2f-850c40bc9f6b",
                            "chatbot_step_id": "1536b3b4-e4c6-4cea-a428-d63599939ce2",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "3ed0de83-377a-4b2d-a17b-8f03be625024",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "323",
                                    "whatsapp_template_name": "new_aapdu_junagadh_advertisement_en_detail_template"
                                },
                                "action_send_dm_wa_template_variable_data": [
                                    {
                                        "action_send_dm_wa_template_variable_id": "05fcc1cf-3db9-4fb6-838e-1cc476061e81",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "94baf0d3-2fea-4ed1-9845-7c08c0c87535",
                                            "chatbot_custom_variable_name": "new_aapdu_junagadh_advertisement_en_detail_template_header_image",
                                            "fallback_value": "https://storage.writewiz-staging.in/chronox/general/advertisementAapduJunagadh_1736489441166.jpg"
                                        },
                                        "whatsapp_template_dynamic_variable_id": "257",
                                        "fallback_value": ""
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "-570",
                        "chatbot_step_y_axis": "-615"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "e48c703b-73b5-436f-9ce9-5356d238d5f7",
                            "chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "parent_chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "f4a1d0f6-ad88-4e5a-b826-46a4adb3cf10",
                                "condition_group_name": "Match English Language",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "21"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "ff3c0968-d350-440d-8caa-9394de6c71c0",
                            "chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "f50079c9-4853-4e7f-8083-2887b801ad9d",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "362",
                                    "whatsapp_template_name": "new_flow_enquiry_options_en_aapdu_junagadh_template"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        },
                        {
                            "chatbot_step_action_id": "e9c81800-3edf-415e-b38c-d50eecfa3ec6",
                            "chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "sequence": "2",
                            "action_type": {
                                "action_type_id": "e435a612-5fb7-4641-a09d-9a954a1941d1",
                                "action_type_name": "await_user_message"
                            },
                            "action_data": {}
                        },
                        {
                            "chatbot_step_action_id": "852f665a-630a-4ef0-b10c-4b7bf918a962",
                            "chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "sequence": "3",
                            "action_type": {
                                "action_type_id": "182e486a-637f-40ed-976b-5c909d9d094c",
                                "action_type_name": "redirect_to_step"
                            },
                            "action_data": {}
                        }
                    ]
                },
                {
                    "chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                    "flag_start_node": true,
                    "coordinates": {
                        "chatbot_step_x_axis": "-1245",
                        "chatbot_step_y_axis": "225"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "54ba5f95-8954-4c4c-98ed-1eb0c2ba6db4",
                            "chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "parent_chatbot_step_id": null,
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": null
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "223effd5-7c9c-42de-89ad-60ebc6aaad56",
                            "chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "176e39de-234d-4e8c-95f6-e3bf1afe5efa",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "322",
                                    "whatsapp_template_name": "new_welcome_aapdu_junagadh_template_new"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        },
                        {
                            "chatbot_step_action_id": "c7c03b9f-9f68-4ef8-bd7b-a7882c64709c",
                            "chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "sequence": "2",
                            "action_type": {
                                "action_type_id": "e435a612-5fb7-4641-a09d-9a954a1941d1",
                                "action_type_name": "await_user_message"
                            },
                            "action_data": {}
                        },
                        {
                            "chatbot_step_action_id": "5f118705-aebb-48f4-8213-686aa63db8f8",
                            "chatbot_step_id": "3c901d0d-5aef-453f-9168-8805efa8fd1b",
                            "sequence": "3",
                            "action_type": {
                                "action_type_id": "182e486a-637f-40ed-976b-5c909d9d094c",
                                "action_type_name": "redirect_to_step"
                            },
                            "action_data": {}
                        }
                    ]
                },
                {
                    "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "1215",
                        "chatbot_step_y_axis": "-1725"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "00b23d2c-b37e-4941-84a4-d5038008806a",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "dc3130dd-3c1c-43fb-bc64-e27470a8a0be",
                                "condition_group_name": "Match \"Kalva Chowk\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "42"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "4607c54b-4d50-4303-a1d0-d179dbd194eb",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "f696baed-79d1-4d2b-a89b-5ebf9194aa62",
                                "condition_group_name": "Match \"Sardarbaug\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "41"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "7d6d06dc-ea96-4552-a784-5283ee696851",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "7c0d39a7-2f37-4748-a5a6-2807ea23573d",
                                "condition_group_name": "Match \"Gandhigram\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "43"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "888e05e2-9c9e-4fba-ab75-2ee60078565d",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "d0bee169-6e04-45c4-b378-1d20ef8c0ccf",
                                "condition_group_name": "Match \"Other\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "45"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "a318e6b2-d118-4286-b0de-100a66d7d8b9",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "482ac82a-9083-4383-9ff4-7feec69404e3",
                                "condition_group_name": "Match \"Zanzarda Road\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "26"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "a3542447-3292-4e2c-8dea-5a6ca2486361",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "77344e5e-9d2c-45f4-a57b-c474ab0d38fd",
                                "condition_group_name": "Match \"Motibua\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "38"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "b0577d37-903e-48f6-87e8-6b676108858f",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "61640dfe-5d22-479c-8d7c-3d97e0b9180e",
                                "condition_group_name": "Match \"Outside of Junagadh City\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "46"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "c3acd002-e2e5-4d6f-9c64-4ccc4e0e314c",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "d7fa40c9-dfd4-4c54-ab48-15a336e77507",
                                "condition_group_name": "Match \"Joshipura\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "39"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "c91895c7-369f-4b85-862a-080b320cfee8",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "f841e9ef-f962-4bca-82bf-331134becb33",
                                "condition_group_name": "Match \"M.G Road\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "44"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "e7436aab-f1c8-4164-9e96-bf59d216de50",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "parent_chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "08fbb1f0-2377-4b2a-a7ea-4d07089b0df1",
                                "condition_group_name": "Match \"Madhuram\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "40"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "d2342f83-f403-47af-b13a-31f9853e7cf4",
                            "chatbot_step_id": "3f3baba0-ab97-4be8-b11e-075bf6825605",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "bc37c85f-878c-41aa-bef5-3ffd3bd848a4",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "327",
                                    "whatsapp_template_name": "aapdu_junagadh_group_link_en"
                                },
                                "action_send_dm_wa_template_variable_data": [
                                    {
                                        "action_send_dm_wa_template_variable_id": "76a7b519-4ad7-48ea-a443-37d025f7225c",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "e287b3e6-7a0d-4d5e-befd-209e954741ee",
                                            "chatbot_custom_variable_name": "area_map_url_en",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "260"
                                    },
                                    {
                                        "action_send_dm_wa_template_variable_id": "ceedb40b-3e2d-4eff-8ec0-6695c51172e2",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "b9fbe17d-59cf-4176-93b8-da869ae074cc",
                                            "chatbot_custom_variable_name": "area_map_short_url_en",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "294"
                                    },
                                    {
                                        "action_send_dm_wa_template_variable_id": "e9d3de05-b186-44e5-9475-e4aca38ca20c",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "2bd1f896-e009-4e0a-a529-0bacf1d4c790",
                                            "chatbot_custom_variable_name": "area_en",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "259"
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "285",
                        "chatbot_step_y_axis": "-2205"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "fe37dc49-85a8-4cee-a769-dbe4b9d88f7b",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "parent_chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "6d99ba49-db26-4829-81a4-28e325725b6a",
                                "condition_group_name": "Match \"Join WhatsApp Group\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "28"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "d93e3904-6c7d-47f4-a94c-048eab536688",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "37f46fa1-2325-4315-b185-ee2ce436b32e",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "359",
                                    "whatsapp_template_name": "join_whatsapp_group_en"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        },
                        {
                            "chatbot_step_action_id": "a2988498-fd9f-4c55-b759-f406c57a4920",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "2",
                            "action_type": {
                                "action_type_id": "e435a612-5fb7-4641-a09d-9a954a1941d1",
                                "action_type_name": "await_user_message"
                            },
                            "action_data": {}
                        },
                        {
                            "chatbot_step_action_id": "bdf63157-36e0-4e6e-9d08-0c4d8d1046d6",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "3",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "475bbbe7-d775-4d9f-8f6e-baa44928a3cf",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "2bd1f896-e009-4e0a-a529-0bacf1d4c790",
                                    "chatbot_custom_variable_name": "area_en",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_text",
                                "payload_key": null
                            }
                        },
                        {
                            "chatbot_step_action_id": "4e325860-f742-4b8a-a12a-f836546fb9fe",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "4",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "96b67c14-95b0-43cf-85cb-d851e6bdd370",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "b9fbe17d-59cf-4176-93b8-da869ae074cc",
                                    "chatbot_custom_variable_name": "area_map_short_url_en",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_payload",
                                "payload_key": "area_map_short_url_en"
                            }
                        },
                        {
                            "chatbot_step_action_id": "f1bdd89f-bed9-441d-8d58-043c64fbde71",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "5",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "ac6f2764-0b1e-4d50-baa0-164a64643246",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "e287b3e6-7a0d-4d5e-befd-209e954741ee",
                                    "chatbot_custom_variable_name": "area_map_url_en",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_payload",
                                "payload_key": "area_map_url_en"
                            }
                        },
                        {
                            "chatbot_step_action_id": "1ed053ea-c5e2-4fcb-a5f2-ff2ed0d219ab",
                            "chatbot_step_id": "83717a07-4c24-4266-9248-6606420b3d8d",
                            "sequence": "6",
                            "action_type": {
                                "action_type_id": "182e486a-637f-40ed-976b-5c909d9d094c",
                                "action_type_name": "redirect_to_step"
                            },
                            "action_data": {}
                        }
                    ]
                },
                {
                    "chatbot_step_id": "88cb7932-3649-4e0f-964a-876e247c58fe",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "210",
                        "chatbot_step_y_axis": "4830"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "0e985a2d-6f79-4d59-bfb9-e1e1aede91d0",
                            "chatbot_step_id": "88cb7932-3649-4e0f-964a-876e247c58fe",
                            "parent_chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "6b0bf064-5c19-4a86-84d0-d31f4326a92f",
                                "condition_group_name": "Match \"હાલની જોબ ઓપનિંગ\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "37"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "6e5e4f69-f903-45b1-9505-d5028807cc22",
                            "chatbot_step_id": "88cb7932-3649-4e0f-964a-876e247c58fe",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "7111308c-66ae-4cd8-80a6-19344aea58e1",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "326",
                                    "whatsapp_template_name": "new_job_openings_gu_aapdu_junagadh_template"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "8efae130-783e-4ec6-abc5-a6992f800605",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "225",
                        "chatbot_step_y_axis": "3120"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "415c5ae5-cb68-441e-9c84-4b65dcde7896",
                            "chatbot_step_id": "8efae130-783e-4ec6-abc5-a6992f800605",
                            "parent_chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "51e5793c-f710-4ba1-9ada-50a06a3aa8b7",
                                "condition_group_name": "Match \"સંપર્ક વિગતો જાણો\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "35"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "5385edea-dce9-44c1-a813-49fe904dba10",
                            "chatbot_step_id": "8efae130-783e-4ec6-abc5-a6992f800605",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "a1baf0e8-c3b5-4b70-b81d-4d9c1ba32f52",
                                "action_type_name": "send_WA_DM_text"
                            },
                            "action_data": {
                                "action_text_message_id": "cb484947-3a00-4ab9-b00d-1b1aea141e01",
                                "action_text_message_variant_data": [
                                    {
                                        "action_text_message_value": "9510812000 / 9033236312 (અમારી ટીમ આપની મદદ કરવા માટે તૈયાર છે. અમારો સંપર્ક કરો.)",
                                        "action_text_message_variant_id": "620d6f1e-d4dd-4729-8fd4-f2fe32bc4c61"
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "270",
                        "chatbot_step_y_axis": "1620"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "90e37c77-210f-4093-92e4-4ad87a044385",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "parent_chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "6abe6993-8ca5-4cf3-9edd-ab9e1685e643",
                                "condition_group_name": "Match \"વોટ્સએપ ગ્રુપમાં જોડાઓ\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "29"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "7d97e3de-109c-4227-a986-99224d2e94fc",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "3aef6a02-cf1f-4880-b249-53c01beb59b9",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "361",
                                    "whatsapp_template_name": "join_whatsapp_group_gu"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        },
                        {
                            "chatbot_step_action_id": "1f3326a4-ce84-4c92-a469-a35f9ad11e70",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "2",
                            "action_type": {
                                "action_type_id": "e435a612-5fb7-4641-a09d-9a954a1941d1",
                                "action_type_name": "await_user_message"
                            },
                            "action_data": {}
                        },
                        {
                            "chatbot_step_action_id": "3c9202ef-f6a5-4540-b467-35885806bf92",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "3",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "4ce6d79f-0606-421a-892e-e6f868e14160",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "bada3460-f2df-42c4-a4ba-26bfdcf6ef0d",
                                    "chatbot_custom_variable_name": "area_gu",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_text",
                                "payload_key": null
                            }
                        },
                        {
                            "chatbot_step_action_id": "134e64a4-1b85-41bf-bc44-f9819dcbc82f",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "4",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "d4e9f4eb-fca5-4f8a-8792-b8e5e6acaef0",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "bbb517f9-786c-4801-925e-53b0a9e2824b",
                                    "chatbot_custom_variable_name": "area_map_short_url_gu",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_payload",
                                "payload_key": "area_map_short_url_gu"
                            }
                        },
                        {
                            "chatbot_step_action_id": "7cb99cb3-9e4c-4ec0-bf94-b44556602674",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "5",
                            "action_type": {
                                "action_type_id": "d92ffa84-c419-41db-8815-cacba185db48",
                                "action_type_name": "save_variable"
                            },
                            "action_data": {
                                "action_save_variable_id": "df01da45-da12-4e06-a7fc-3bf6280e3b7d",
                                "chatbot_custom_variable_configuration": {
                                    "chatbot_custom_variable_configuration_id": "6070ae0a-044f-48b8-a5e5-386118a4dff4",
                                    "chatbot_custom_variable_name": "area_map_url_gu",
                                    "fallback_value": null
                                },
                                "value_type": "user_message_payload",
                                "payload_key": "area_map_url_gu"
                            }
                        },
                        {
                            "chatbot_step_action_id": "0c10a41e-bd33-4a3e-8376-047302ef23ca",
                            "chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "sequence": "6",
                            "action_type": {
                                "action_type_id": "182e486a-637f-40ed-976b-5c909d9d094c",
                                "action_type_name": "redirect_to_step"
                            },
                            "action_data": {}
                        }
                    ]
                },
                {
                    "chatbot_step_id": "a7c7312c-7689-4d5e-86de-ab21fd0cdf6c",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "255",
                        "chatbot_step_y_axis": "870"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "ad052dc1-b462-4653-8289-b55e06cff5a8",
                            "chatbot_step_id": "a7c7312c-7689-4d5e-86de-ab21fd0cdf6c",
                            "parent_chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "af8f9709-1c8a-4504-b7da-f112f58fae9c",
                                "condition_group_name": "Match \"Current Job Openings\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "34"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "efff62a1-b43f-4127-b47e-947ed20d50b6",
                            "chatbot_step_id": "a7c7312c-7689-4d5e-86de-ab21fd0cdf6c",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "76a26acb-8089-4a71-aeac-89b341f0755d",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "325",
                                    "whatsapp_template_name": "new_job_openings_en_aapdu_junagadh_template_new"
                                },
                                "action_send_dm_wa_template_variable_data": []
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "1380",
                        "chatbot_step_y_axis": "1995"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "06d4d8bb-a007-4223-8cd4-09b1a9f34fc1",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "99138c74-2b7b-46ed-b777-cd367e8b21b2",
                                "condition_group_name": "MATCH \"મધુરામ એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "49"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "11e5dfcd-ff12-411f-a5aa-ff97c7f6fbfd",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "8955c2a9-5dd6-48e7-b93e-efd0d9afb26a",
                                "condition_group_name": "MATCH \"M.G રોડ\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "53"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "29fdf64b-17f5-4fd2-8b9e-ef8aae3e8bed",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "e6418358-a491-47f1-a0f3-8baf83370386",
                                "condition_group_name": "MATCH \"ગાંધીગ્રામ એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "52"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "96760fe1-754a-44a9-ab79-13269eb5ae5b",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "31f810c9-2aa6-480e-ae32-3022e684b2bc",
                                "condition_group_name": "MATCH \"અન્ય\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "54"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "b12c7924-8d1f-4dc3-b952-f1d1bfa29a94",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "77cde349-c6f9-4b1b-a3d0-52928a6c84a6",
                                "condition_group_name": "MATCH \"ઝાંઝરડા રોડ એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "27"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "b3bc9455-00dd-4128-8a15-3ba9a7ee1823",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "53e7f20c-a4f0-4cd0-ae9d-dbc8bf3ab8f9",
                                "condition_group_name": "MATCH \"સરદારબાગ એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "50"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "b69ad1ec-1c7a-4b1d-baab-b9eccdbffc07",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "4a5f4aef-12cc-450c-af27-ab0a2df4d837",
                                "condition_group_name": "MATCH \"કળવા ચોક એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "51"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "ba6271db-6504-4955-937f-fc159fc255d7",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "752ac547-20f8-41d4-a074-0a201b4d6b8e",
                                "condition_group_name": "MATCH \"મોતીબાગ એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "47"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "ec5899fd-e619-4570-b2bb-483c03b69b8f",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "bf7e81a3-3a36-4526-ac95-f63cad8cedcd",
                                "condition_group_name": "MATCH \"જૂનાગઢ શહેર ની બહાર\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "55"
                            }
                        },
                        {
                            "chatbot_step_flow_id": "fed7f53e-ec1f-467a-9113-d541ecb53366",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "parent_chatbot_step_id": "a5387a69-ad78-452b-91c4-66d3ae1f81c0",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "303c81f5-1c46-4036-9083-35b4ac5de8ff",
                                "condition_group_name": "MATCH \"જોશીપુરા એરિયા\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "48"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "161a7893-14f4-4042-950a-2d4d6edd6f05",
                            "chatbot_step_id": "d7443db3-5631-412e-a7ce-c7d336a1a885",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "a97fc2a5-d54d-4806-adf8-65907ef10b4f",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "328",
                                    "whatsapp_template_name": "group_link_gu"
                                },
                                "action_send_dm_wa_template_variable_data": [
                                    {
                                        "action_send_dm_wa_template_variable_id": "9b024d7c-a997-426f-8aa1-3fdca78babf0",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "6070ae0a-044f-48b8-a5e5-386118a4dff4",
                                            "chatbot_custom_variable_name": "area_map_url_gu",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "262"
                                    },
                                    {
                                        "action_send_dm_wa_template_variable_id": "a62e43b1-7a4c-487e-a507-1da649869fed",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "bada3460-f2df-42c4-a4ba-26bfdcf6ef0d",
                                            "chatbot_custom_variable_name": "area_gu",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "261"
                                    },
                                    {
                                        "action_send_dm_wa_template_variable_id": "c6c93045-cdd7-42d8-a282-2a1b7f47c60c",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "bbb517f9-786c-4801-925e-53b0a9e2824b",
                                            "chatbot_custom_variable_name": "area_map_short_url_gu",
                                            "fallback_value": null
                                        },
                                        "whatsapp_template_dynamic_variable_id": "293"
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "e9a3bd1b-684f-4063-bf44-1515efc9a137",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "210",
                        "chatbot_step_y_axis": "3990"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "3500e68b-a125-4f86-8e0c-86b6b4a64d86",
                            "chatbot_step_id": "e9a3bd1b-684f-4063-bf44-1515efc9a137",
                            "parent_chatbot_step_id": "0d1b331b-6db6-47cd-b4ea-f1056022fc51",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "f21959f9-ab5a-491c-b63a-e737dc126e2f",
                                "condition_group_name": "Match \"જાહેરાત પેકેજ\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "36"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "91869622-859d-420a-b608-443fd6b58d43",
                            "chatbot_step_id": "e9a3bd1b-684f-4063-bf44-1515efc9a137",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "d19c4d0c-9f29-4358-b1f5-116b29aaa768",
                                "action_type_name": "send_WA_DM_template"
                            },
                            "action_data": {
                                "action_send_dm_wa_template_id": "7f6de45e-324b-4eae-a176-9441619efc30",
                                "whatsapp_template": {
                                    "whatsapp_template_id": "324",
                                    "whatsapp_template_name": "aapdu_junagadh_advertisement_gu_detail_template"
                                },
                                "action_send_dm_wa_template_variable_data": [
                                    {
                                        "action_send_dm_wa_template_variable_id": "9dcccb19-fbaf-4a47-9614-a902abb98c16",
                                        "variable_type": {
                                            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
                                            "variable_type_name": "Custom"
                                        },
                                        "chatbot_custom_variable_configuration": {
                                            "chatbot_custom_variable_configuration_id": "63aac37c-1b8f-456e-b3a9-0cd18db6a4c6",
                                            "chatbot_custom_variable_name": "aapdu_junagadh_advertisement_gu_detail_template",
                                            "fallback_value": "https://storage.writewiz-staging.in/chronox/general/advertisementAapduJunagadh_1736489441166.jpg"
                                        },
                                        "whatsapp_template_dynamic_variable_id": "258"
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "chatbot_step_id": "f6ee9e3b-20af-4faa-b3d6-32b9bbd2ad70",
                    "flag_start_node": false,
                    "coordinates": {
                        "chatbot_step_x_axis": "210",
                        "chatbot_step_y_axis": "-735"
                    },
                    "chatbot_step_flow": [
                        {
                            "chatbot_step_flow_id": "ae77c371-21dd-4989-b954-dbd9cc8335c1",
                            "chatbot_step_id": "f6ee9e3b-20af-4faa-b3d6-32b9bbd2ad70",
                            "parent_chatbot_step_id": "38e608f3-d76a-4efb-9a98-d3307ef695d7",
                            "chatbot_id": "f780ab6e-b137-4502-84b7-e3aa9def2d0e",
                            "condition_group": {
                                "condition_group_id": "19573970-2bdb-44a2-9faa-1158589516ea",
                                "condition_group_name": "Match \"Know the Contact Details\"",
                                "flag_advanced_condition": false,
                                "interactive_component": "template_button",
                                "interactive_component_id": "32"
                            }
                        }
                    ],
                    "chatbot_step_action_data": [
                        {
                            "chatbot_step_action_id": "a193ac22-586a-49c0-a1d4-a7b4c9e634ef",
                            "chatbot_step_id": "f6ee9e3b-20af-4faa-b3d6-32b9bbd2ad70",
                            "sequence": "1",
                            "action_type": {
                                "action_type_id": "a1baf0e8-c3b5-4b70-b81d-4d9c1ba32f52",
                                "action_type_name": "send_WA_DM_text"
                            },
                            "action_data": {
                                "action_text_message_id": "10d03f92-482e-4190-ad44-511ccd621946",
                                "action_text_message_variant_data": [
                                    {
                                        "action_text_message_value": "Thank you for your interest. You can reach us at 9510812000 or 9033236312. We look forward to hearing from you!",
                                        "action_text_message_variant_id": "c9c7efe6-a7fb-464c-b5e7-e2849e157949"
                                    }
                                ]
                            }
                        }
                    ]
                }
            ]
        }
    ],
    "additional_data": {
        "whatsapp_templates": [
            {
                "whatsapp_template_id": 324,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:21:36.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 21,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "aapdu_junagadh_advertisement_gu_detail_template",
                    "whatsapp_template_description": "aapdu_junagadh_advertisement_gu_detail_template",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 25,
                        "whatsapp_language_name": "Gujarati",
                        "whatsapp_language_abbr": "gu"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": 240,
                        "whatsapp_template_header_type_id": "2",
                        "whatsapp_template_header_type_name": "Image",
                        "whatsapp_template_header_data": [
                            {
                                "whatsapp_template_header_data_id": 365,
                                "whatsapp_template_header_data_value": null,
                                "whatsapp_template_header_data_google_storage_id": 3320,
                                "whatsapp_template_header_variable_data": [
                                    {
                                        "whatsapp_template_dynamic_variable_id": 258,
                                        "whatsapp_template_dynamic_variable_type_id": 3,
                                        "whatsapp_template_dynamic_variable_unique_id": 240,
                                        "whatsapp_template_dynamic_variable_key": "{{HeaderImage}}",
                                        "whatsapp_template_dynamic_variable_sample_value": "https://storage.writewiz-staging.in/chronox/chatbot/SampleJPGImage_100kbmb_1738329330023.jpg",
                                        "flag_header": true,
                                        "flag_button": false,
                                        "whatsapp_template_dynamic_variable_type_name": "Header"
                                    }
                                ]
                            }
                        ]
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 25,
                        "whatsapp_template_body_value": "આપના સંપર્ક માટે આભાર.\nઅમે આશા રાખીએ છીએ કે આ માહિતી ઉપયોગી થશે.\n\nકોઈપણ પ્રશ્ન માટે અમારા નંબર 9510812000 અથવા 9033236312 પર કૉલ કરવામાં અચકાશો નહીં.",
                        "whatsapp_template_body_description": "આપના સંપર્ક માટે આભાર.\nઅમે આશા રાખીએ છીએ કે આ માહિતી ઉપયોગી થશે.\n\nકોઈપણ પ્રશ્ન માટે અમારા નંબર 9510812000 અથવા 9033236312 પર કૉલ કરવામાં અચકાશો નહીં.",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": []
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 341,
                    "meta_whatsapp_template_id": "2100683913695520",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 363,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-02-05T00:48:41.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 30,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "enquiry_options_gu_aapdu_junagadh_template_new",
                    "whatsapp_template_description": "these are the enquiry options for aapdu junagadh",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 25,
                        "whatsapp_language_name": "Gujarati",
                        "whatsapp_language_abbr": "gu"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 35,
                        "whatsapp_template_body_value": "કૃપા કરીને પસંદ કરો કે અમે આજે તમને કેવી રીતે મદદ કરી શકીએ👇",
                        "whatsapp_template_body_description": "this is an intruction to select the button what they want help in",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 29,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 0,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 65,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 107,
                                            "whatsapp_template_button_data_id": "65",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "વોટ્સએપ ગ્રુપમાં જોડાઓ",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 35,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 1,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 66,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 108,
                                            "whatsapp_template_button_data_id": "66",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "સંપર્ક વિગતો જાણો",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 36,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 2,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 67,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 109,
                                            "whatsapp_template_button_data_id": "67",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "જાહેરાત પેકેજ",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 37,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 3,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 68,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 110,
                                            "whatsapp_template_button_data_id": "68",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "હાલની જોબ ઓપનિંગ",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 383,
                    "meta_whatsapp_template_id": "1134168868363144",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 323,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:19:42.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 20,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "new_aapdu_junagadh_advertisement_en_detail_template",
                    "whatsapp_template_description": "new_aapdu_junagadh_advertisement_en_detail_template",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": 239,
                        "whatsapp_template_header_type_id": "2",
                        "whatsapp_template_header_type_name": "Image",
                        "whatsapp_template_header_data": [
                            {
                                "whatsapp_template_header_data_id": 364,
                                "whatsapp_template_header_data_value": null,
                                "whatsapp_template_header_data_google_storage_id": 3320,
                                "whatsapp_template_header_variable_data": [
                                    {
                                        "whatsapp_template_dynamic_variable_id": 257,
                                        "whatsapp_template_dynamic_variable_type_id": 3,
                                        "whatsapp_template_dynamic_variable_unique_id": 239,
                                        "whatsapp_template_dynamic_variable_key": "{{HeaderImage}}",
                                        "whatsapp_template_dynamic_variable_sample_value": "https://storage.writewiz-staging.in/chronox/chatbot/SampleJPGImage_100kbmb_1738329330023.jpg",
                                        "flag_header": true,
                                        "flag_button": false,
                                        "whatsapp_template_dynamic_variable_type_name": "Header"
                                    }
                                ]
                            }
                        ]
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 24,
                        "whatsapp_template_body_value": "Thank you for your interest in advertising with us!\nWe offer a variety of effective advertising packages to help you reach your target audience.\n\nYou can also contact us at 9510812000 or 9033236312 to discuss your specific needs and get a personalized quote.",
                        "whatsapp_template_body_description": "Thank you for your interest in advertising with us!\nWe offer a variety of effective advertising packages to help you reach your target audience.\n\nYou can also contact us at 9510812000 or 9033236312 to discuss your specific needs and get a personalized quote.",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": []
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 340,
                    "meta_whatsapp_template_id": "884934577049220",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 327,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:32:35.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 24,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "aapdu_junagadh_group_link_en",
                    "whatsapp_template_description": "aapdu_junagadh_group_link_en",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 28,
                        "whatsapp_template_body_value": "You have selected the *{{1}}* area. Click on the link below to join the group for this area:\n*https://chat.whatsapp.com/{{2}}*",
                        "whatsapp_template_body_description": "You have selected the *{{1}}* area. Click on the link below to join the group for this area:\n*https://chat.whatsapp.com/{{2}}*",
                        "whatsapp_template_body_variable_data": [
                            {
                                "whatsapp_template_dynamic_variable_id": 259,
                                "whatsapp_template_dynamic_variable_type_id": 1,
                                "whatsapp_template_dynamic_variable_unique_id": 28,
                                "whatsapp_template_dynamic_variable_key": "{{1}}",
                                "whatsapp_template_dynamic_variable_sample_value": "Zanzarda Road Area",
                                "flag_header": false,
                                "flag_button": false,
                                "whatsapp_template_dynamic_variable_type_name": "Body"
                            },
                            {
                                "whatsapp_template_dynamic_variable_id": 260,
                                "whatsapp_template_dynamic_variable_type_id": 1,
                                "whatsapp_template_dynamic_variable_unique_id": 28,
                                "whatsapp_template_dynamic_variable_key": "{{2}}",
                                "whatsapp_template_dynamic_variable_sample_value": "GLw7ijrFsFk0uoRjPxSc23",
                                "flag_header": false,
                                "flag_button": false,
                                "whatsapp_template_dynamic_variable_type_name": "Body"
                            }
                        ]
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 24,
                            "whatsapp_template_button_type_id": "2",
                            "whatsapp_template_button_index": null,
                            "whatsapp_template_button_type_name": "Call to action",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 39,
                                    "whatsapp_template_button_sub_type_id": "3",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 79,
                                            "whatsapp_template_button_data_id": "39",
                                            "whatsapp_template_button_sub_type_field_id": "5",
                                            "whatsapp_template_button_sub_type_field_value": "https://bit.ly/{{1}}",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Website URL",
                                            "field_type": "Textfield",
                                            "field_placeholder": "https://www.example.com",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "url",
                                            "whatsapp_template_button_field_data_variable": [
                                                {
                                                    "whatsapp_template_dynamic_variable_id": 294,
                                                    "whatsapp_template_dynamic_variable_type_id": 2,
                                                    "whatsapp_template_dynamic_variable_unique_id": 79,
                                                    "whatsapp_template_dynamic_variable_key": "{{1}}",
                                                    "whatsapp_template_dynamic_variable_sample_value": "3PLOAiC",
                                                    "flag_header": false,
                                                    "flag_button": true,
                                                    "whatsapp_template_dynamic_variable_type_name": "Button Field"
                                                }
                                            ]
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 77,
                                            "whatsapp_template_button_data_id": "39",
                                            "whatsapp_template_button_sub_type_field_id": "3",
                                            "whatsapp_template_button_sub_type_field_value": "Join Group",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Visit website",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 78,
                                            "whatsapp_template_button_data_id": "39",
                                            "whatsapp_template_button_sub_type_field_id": "4",
                                            "whatsapp_template_button_sub_type_field_value": null,
                                            "whatsapp_template_button_sub_type_field_option_id": "3",
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "URL Type",
                                            "field_type": "Autocomplete",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": true,
                                            "field_option_value": "Dynamic",
                                            "field_meta_key_name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 344,
                    "meta_whatsapp_template_id": "1659404407991743",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 362,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-02-04T09:14:39.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 29,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "new_flow_enquiry_options_en_aapdu_junagadh_template",
                    "whatsapp_template_description": "this template is to show the options in which aapdu junagadh can help the user out",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 34,
                        "whatsapp_template_body_value": "Please select how may we help you today 👇",
                        "whatsapp_template_body_description": "this is a message that we have below options",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 28,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 0,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 61,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 103,
                                            "whatsapp_template_button_data_id": "61",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Join WhatsApp Group",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 32,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 1,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 62,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 104,
                                            "whatsapp_template_button_data_id": "62",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Know the Contact Details",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 33,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 2,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 63,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 105,
                                            "whatsapp_template_button_data_id": "63",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Advertisement Package",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 34,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 3,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 64,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 106,
                                            "whatsapp_template_button_data_id": "64",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Current Job Openings",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 381,
                    "meta_whatsapp_template_id": "1801202830628129",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 328,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:33:43.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 25,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "group_link_gu",
                    "whatsapp_template_description": "group_link_gu",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 25,
                        "whatsapp_language_name": "Gujarati",
                        "whatsapp_language_abbr": "gu"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 29,
                        "whatsapp_template_body_value": "તમે *{{1}}* વિસ્તાર પસંદ કર્યો છે. નીચેની લિંક પર ક્લિક કરીને તમે આ વિસ્તારના ગ્રુપમાં જોડાઈ શકો છો:\nhttps://chat.whatsapp.com/{{2}}",
                        "whatsapp_template_body_description": "તમે *{{1}}* વિસ્તાર પસંદ કર્યો છે. નીચેની લિંક પર ક્લિક કરીને તમે આ વિસ્તારના ગ્રુપમાં જોડાઈ શકો છો:\nhttps://chat.whatsapp.com/{{2}}",
                        "whatsapp_template_body_variable_data": [
                            {
                                "whatsapp_template_dynamic_variable_id": 261,
                                "whatsapp_template_dynamic_variable_type_id": 1,
                                "whatsapp_template_dynamic_variable_unique_id": 29,
                                "whatsapp_template_dynamic_variable_key": "{{1}}",
                                "whatsapp_template_dynamic_variable_sample_value": "ઝાંઝરડા રોડ એરિયા",
                                "flag_header": false,
                                "flag_button": false,
                                "whatsapp_template_dynamic_variable_type_name": "Body"
                            },
                            {
                                "whatsapp_template_dynamic_variable_id": 262,
                                "whatsapp_template_dynamic_variable_type_id": 1,
                                "whatsapp_template_dynamic_variable_unique_id": 29,
                                "whatsapp_template_dynamic_variable_key": "{{2}}",
                                "whatsapp_template_dynamic_variable_sample_value": "GLw7ijrFsFk0uoRjPxSc23",
                                "flag_header": false,
                                "flag_button": false,
                                "whatsapp_template_dynamic_variable_type_name": "Body"
                            }
                        ]
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 25,
                            "whatsapp_template_button_type_id": "2",
                            "whatsapp_template_button_index": null,
                            "whatsapp_template_button_type_name": "Call to action",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 40,
                                    "whatsapp_template_button_sub_type_id": "3",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 82,
                                            "whatsapp_template_button_data_id": "40",
                                            "whatsapp_template_button_sub_type_field_id": "5",
                                            "whatsapp_template_button_sub_type_field_value": "https://bit.ly/{{1}}",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Website URL",
                                            "field_type": "Textfield",
                                            "field_placeholder": "https://www.example.com",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "url",
                                            "whatsapp_template_button_field_data_variable": [
                                                {
                                                    "whatsapp_template_dynamic_variable_id": 293,
                                                    "whatsapp_template_dynamic_variable_type_id": 2,
                                                    "whatsapp_template_dynamic_variable_unique_id": 82,
                                                    "whatsapp_template_dynamic_variable_key": "{{1}}",
                                                    "whatsapp_template_dynamic_variable_sample_value": "3PLOAiC",
                                                    "flag_header": false,
                                                    "flag_button": true,
                                                    "whatsapp_template_dynamic_variable_type_name": "Button Field"
                                                }
                                            ]
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 80,
                                            "whatsapp_template_button_data_id": "40",
                                            "whatsapp_template_button_sub_type_field_id": "3",
                                            "whatsapp_template_button_sub_type_field_value": "ગ્રુપમાં જોડાઓ",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Visit website",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 81,
                                            "whatsapp_template_button_data_id": "40",
                                            "whatsapp_template_button_sub_type_field_id": "4",
                                            "whatsapp_template_button_sub_type_field_value": null,
                                            "whatsapp_template_button_sub_type_field_option_id": "3",
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "URL Type",
                                            "field_type": "Autocomplete",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": true,
                                            "field_option_value": "Dynamic",
                                            "field_meta_key_name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 345,
                    "meta_whatsapp_template_id": "2407582352920544",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 361,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-02-04T08:52:13.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 28,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "join_whatsapp_group_gu",
                    "whatsapp_template_description": "whatsapp groups of junagadh area in gujarati language",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 25,
                        "whatsapp_language_name": "Gujarati",
                        "whatsapp_language_abbr": "gu"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 33,
                        "whatsapp_template_body_value": "જય ગિરનારી! 😊🙏\n\nતમારા એરિયા મુજબના વોટ્સએપ ગ્રુપ સાથે જોડાવવા માટે તમારો એરિયા પસંદ કરો. અમે આપ સૌને સોશિયલ મીડિયાના માધ્યમથી જોડવા માટે આતુર છીએ!\\nધન્યવાદ! 😊",
                        "whatsapp_template_body_description": "this is a welcome message and instruction to select the area in which they want to join",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 27,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 0,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 51,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 93,
                                            "whatsapp_template_button_data_id": "51",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "ઝાંઝરડા રોડ એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "51",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 137,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "GLw7ijrFsFk0uoRjPxSc23"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 136,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "3PLOAiC"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 47,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 1,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 52,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 94,
                                            "whatsapp_template_button_data_id": "52",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "મોતીબાગ એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "52",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 138,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4jnVBUt"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 139,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "HubHcT2WrTHGhZdGqQYyz5"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 48,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 2,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 53,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 95,
                                            "whatsapp_template_button_data_id": "53",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "જોશીપુરા એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "53",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 141,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "FFrO0rG4nTI0dYVvDkDPNZ"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 140,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4h60D6w"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 49,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 3,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 54,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 96,
                                            "whatsapp_template_button_data_id": "54",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "મધુરામ એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "54",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 142,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4hl1xvA"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 143,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "GgvgwGfeixEGY3R7shADMo"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 50,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 4,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 55,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 97,
                                            "whatsapp_template_button_data_id": "55",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "સરદારબાગ એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "55",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 144,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "40iXHfu"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 145,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "FRM8MBcPk9TAiJuK3Hf2Om"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 51,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 5,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 56,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 98,
                                            "whatsapp_template_button_data_id": "56",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "કળવા ચોક એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "56",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 147,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "FAHR4EH14SWHryxuKG9PjV"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 146,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "3C7HNgf"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 52,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 6,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 57,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 99,
                                            "whatsapp_template_button_data_id": "57",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "ગાંધીગ્રામ એરિયા",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "57",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 149,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "JHez35HBEJF1ag443dcxSi"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 148,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4atls9x"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 53,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 7,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 58,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 100,
                                            "whatsapp_template_button_data_id": "58",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "M.G રોડ",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "58",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 150,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "40J6EAv"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 151,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "BQYu6hafHXa7SZbmTJqu4E"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 54,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 8,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 59,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 101,
                                            "whatsapp_template_button_data_id": "59",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "અન્ય",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "59",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 152,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4g7Ctan"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 153,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "JfMsdPMFrx7HiSMpRTQQoU"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 55,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 9,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 60,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 102,
                                            "whatsapp_template_button_data_id": "60",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "જૂનાગઢ શહેર ની બહાર",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "60",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 154,
                                                    "payload_key": "area_map_short_url_gu",
                                                    "payload_key_value": "4aurE0N"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 155,
                                                    "payload_key": "area_map_url_gu",
                                                    "payload_key_value": "BdnUicLOrnyBdAzDzsP2IC"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 379,
                    "meta_whatsapp_template_id": "979934573526266",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 325,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:22:29.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 22,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "new_job_openings_en_aapdu_junagadh_template_new",
                    "whatsapp_template_description": "new_job_openings_en_aapdu_junagadh_template_new",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 26,
                        "whatsapp_template_body_value": "Thank you for your interest in career opportunities at Aapdu Junagadh.\n\nPlease visit our careers page at https://aapdujunagadh.com/aj/career.php to view a list of current job openings.\n\nWe encourage you to explore our available positions and apply online.\n\nWe look forward to your application!",
                        "whatsapp_template_body_description": "Thank you for your interest in career opportunities at Aapdu Junagadh.\n\nPlease visit our careers page at https://aapdujunagadh.com/aj/career.php to view a list of current job openings.\n\nWe encourage you to explore our available positions and apply online.\n\nWe look forward to your application!",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 22,
                            "whatsapp_template_button_type_id": "2",
                            "whatsapp_template_button_index": null,
                            "whatsapp_template_button_type_name": "Call to action",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 37,
                                    "whatsapp_template_button_sub_type_id": "3",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 73,
                                            "whatsapp_template_button_data_id": "37",
                                            "whatsapp_template_button_sub_type_field_id": "5",
                                            "whatsapp_template_button_sub_type_field_value": "https://aapdujunagadh.com/aj/career.php",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Website URL",
                                            "field_type": "Textfield",
                                            "field_placeholder": "https://www.example.com",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "url"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 71,
                                            "whatsapp_template_button_data_id": "37",
                                            "whatsapp_template_button_sub_type_field_id": "3",
                                            "whatsapp_template_button_sub_type_field_value": "Visit",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Visit website",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 72,
                                            "whatsapp_template_button_data_id": "37",
                                            "whatsapp_template_button_sub_type_field_id": "4",
                                            "whatsapp_template_button_sub_type_field_value": null,
                                            "whatsapp_template_button_sub_type_field_option_id": "2",
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "URL Type",
                                            "field_type": "Autocomplete",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": true,
                                            "field_option_value": "Static",
                                            "field_meta_key_name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 342,
                    "meta_whatsapp_template_id": "909316737667704",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 322,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:03:30.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 19,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "new_welcome_aapdu_junagadh_template_new",
                    "whatsapp_template_description": "new_welcome_aapdu_junagadh_template_new",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 23,
                        "whatsapp_template_body_value": "Jay Girnari, Welcome to Aapdu Junagadh!\n\nWe are Team Aapdu Junagadh, here to answer all your enquiries that you may have about Aapdu Junagadh.\n\nPlease select the language from the below-mentioned options",
                        "whatsapp_template_body_description": "Jay Girnari, Welcome to Aapdu Junagadh!\n\nWe are Team Aapdu Junagadh, here to answer all your enquiries that you may have about Aapdu Junagadh.\n\nPlease select the language from the below-mentioned options",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 21,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 0,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 35,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 69,
                                            "whatsapp_template_button_data_id": "35",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "English",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 31,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 1,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 36,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 70,
                                            "whatsapp_template_button_data_id": "36",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Gujarati",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 339,
                    "meta_whatsapp_template_id": "622929063648501",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 326,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-01-31T15:23:32.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 23,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "new_job_openings_gu_aapdu_junagadh_template",
                    "whatsapp_template_description": "new_job_openings_gu_aapdu_junagadh_template",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 25,
                        "whatsapp_language_name": "Gujarati",
                        "whatsapp_language_abbr": "gu"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 27,
                        "whatsapp_template_body_value": "નમસ્તે,\n\nતમે જોબ ઓપનિંગ વિકલ્પ પસંદ કર્યો છે. અહીં  Aapdu Junagadh માં ચાલી રહેલી નવીનતમ જોબ્સ માટેની લિંક છે:\n\nhttps://aapdujunagadh.com/aj/career.php\n\nઆ લિંક પર ક્લિક કરીને તમે વિગતવાર માહિતી મેળવી શકો છો અને અરજી કરી શકો છો",
                        "whatsapp_template_body_description": "નમસ્તે,\n\nતમે જોબ ઓપનિંગ વિકલ્પ પસંદ કર્યો છે. અહીં  Aapdu Junagadh માં ચાલી રહેલી નવીનતમ જોબ્સ માટેની લિંક છે:\n\nhttps://aapdujunagadh.com/aj/career.php\n\nઆ લિંક પર ક્લિક કરીને તમે વિગતવાર માહિતી મેળવી શકો છો અને અરજી કરી શકો છો",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 23,
                            "whatsapp_template_button_type_id": "2",
                            "whatsapp_template_button_index": null,
                            "whatsapp_template_button_type_name": "Call to action",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 38,
                                    "whatsapp_template_button_sub_type_id": "3",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 76,
                                            "whatsapp_template_button_data_id": "38",
                                            "whatsapp_template_button_sub_type_field_id": "5",
                                            "whatsapp_template_button_sub_type_field_value": "https://aapdujunagadh.com/aj/career.php",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Website URL",
                                            "field_type": "Textfield",
                                            "field_placeholder": "https://www.example.com",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "url"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 74,
                                            "whatsapp_template_button_data_id": "38",
                                            "whatsapp_template_button_sub_type_field_id": "3",
                                            "whatsapp_template_button_sub_type_field_value": "અહીં ક્લિક કરો",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Visit website",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_field_data_id": 75,
                                            "whatsapp_template_button_data_id": "38",
                                            "whatsapp_template_button_sub_type_field_id": "4",
                                            "whatsapp_template_button_sub_type_field_value": null,
                                            "whatsapp_template_button_sub_type_field_option_id": "2",
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "URL Type",
                                            "field_type": "Autocomplete",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": true,
                                            "field_option_value": "Static",
                                            "field_meta_key_name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 343,
                    "meta_whatsapp_template_id": "2304334469950565",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            },
            {
                "whatsapp_template_id": 359,
                "meta_integration_whatsapp_id": "2900",
                "user_assignment_id": "7036",
                "username": "null",
                "updated_at_timestamp": "2025-02-04T08:35:45.000Z",
                "whatsapp_template_data": {
                    "whatsapp_template_data_id": 27,
                    "whatsapp_template_category_id": 1,
                    "whatsapp_template_category_name": "Marketing",
                    "whatsapp_template_name": "join_whatsapp_group_en",
                    "whatsapp_template_description": "this template is to show the junagadh areas in which the user might want to enroll the whatsapp group",
                    "whatsapp_language_data": {
                        "whatsapp_language_id": 15,
                        "whatsapp_language_name": "English",
                        "whatsapp_language_abbr": "en"
                    },
                    "whatsapp_template_header": {
                        "whatsapp_template_header_id": null,
                        "whatsapp_template_header_type_id": null,
                        "whatsapp_template_header_type_name": null
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_id": 32,
                        "whatsapp_template_body_value": "Jay girnari! 🙏\n\nTo join a group based on your area, Please select your area. We’re excited to have you with us! Thank you! 😊",
                        "whatsapp_template_body_description": "this is a welcome message and instruction to select the area in which they want to join",
                        "whatsapp_template_body_variable_data": []
                    },
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_id": null,
                        "whatsapp_template_footer_value": null
                    },
                    "whatsapp_template_button": [
                        {
                            "whatsapp_template_button_id": 26,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 0,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 41,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 83,
                                            "whatsapp_template_button_data_id": "41",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Zanzarda Road Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "41",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 117,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "GLw7ijrFsFk0uoRjPxSc23"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 116,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "3PLOAiC"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 38,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 1,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 42,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 84,
                                            "whatsapp_template_button_data_id": "42",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Motibuag Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "42",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 118,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4jnVBUt"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 119,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "HubHcT2WrTHGhZdGqQYyz5"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 39,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 2,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 43,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 85,
                                            "whatsapp_template_button_data_id": "43",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Joshipura Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "43",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 121,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "FFrO0rG4nTI0dYVvDkDPNZ"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 120,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4h60D6w"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 40,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 3,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 44,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 86,
                                            "whatsapp_template_button_data_id": "44",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Madhuram Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "44",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 123,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "GgvgwGfeixEGY3R7shADMo"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 122,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4hl1xvA"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 41,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 4,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 45,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 87,
                                            "whatsapp_template_button_data_id": "45",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Sardarbaug Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "45",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 124,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "40iXHfu"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 125,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "FRM8MBcPk9TAiJuK3Hf2Om"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 42,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 5,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 46,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 88,
                                            "whatsapp_template_button_data_id": "46",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Kalva Chowk Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "46",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 127,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "FAHR4EH14SWHryxuKG9PjV"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 126,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "3C7HNgf"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 43,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 6,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 47,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 89,
                                            "whatsapp_template_button_data_id": "47",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Gandhigram Area",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "47",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 129,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "JHez35HBEJF1ag443dcxSi"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 128,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4atls9x"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 44,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 7,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 48,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 90,
                                            "whatsapp_template_button_data_id": "48",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "M.G Road",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "48",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 131,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "BQYu6hafHXa7SZbmTJqu4E"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 130,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "40J6EAv"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 45,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 8,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 49,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 91,
                                            "whatsapp_template_button_data_id": "49",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Other",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "49",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 133,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "JfMsdPMFrx7HiSMpRTQQoU"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 132,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4g7Ctan"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "whatsapp_template_button_id": 46,
                            "whatsapp_template_button_type_id": "1",
                            "whatsapp_template_button_index": 9,
                            "whatsapp_template_button_type_name": "Quick reply",
                            "whatsapp_template_button_data": [
                                {
                                    "whatsapp_template_button_data_id": 50,
                                    "whatsapp_template_button_sub_type_id": "2",
                                    "whatsapp_template_button_sub_type_field_data": [
                                        {
                                            "whatsapp_template_button_field_data_id": 92,
                                            "whatsapp_template_button_data_id": "50",
                                            "whatsapp_template_button_sub_type_field_id": "9",
                                            "whatsapp_template_button_sub_type_field_value": "Outside of Junagadh City",
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "whatsapp_template_button_sub_type_field_payload_key": null,
                                            "field_name": "Button Text",
                                            "field_type": "Textfield",
                                            "field_placeholder": "Quick Reply",
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "text"
                                        },
                                        {
                                            "whatsapp_template_button_data_id": "50",
                                            "whatsapp_template_button_sub_type_field_id": "13",
                                            "whatsapp_template_button_sub_type_field_value": [
                                                {
                                                    "whatsapp_template_button_field_data_id": 134,
                                                    "payload_key": "area_map_short_url_en",
                                                    "payload_key_value": "4aurE0N"
                                                },
                                                {
                                                    "whatsapp_template_button_field_data_id": 135,
                                                    "payload_key": "area_map_url_en",
                                                    "payload_key_value": "BdnUicLOrnyBdAzDzsP2IC"
                                                }
                                            ],
                                            "whatsapp_template_button_sub_type_field_option_id": null,
                                            "whatsapp_template_button_field_data_flag_deleted": false,
                                            "field_name": "Payload",
                                            "field_type": "Object",
                                            "field_placeholder": null,
                                            "field_static_value_flag": false,
                                            "field_static_value": null,
                                            "field_option_flag": false,
                                            "field_option_value": null,
                                            "field_meta_key_name": "quick_reply"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "whatsapp_template_metadata": {
                    "whatsapp_template_metadata_id": 377,
                    "meta_whatsapp_template_id": "8767541713372902",
                    "meta_whatsapp_template_status_id": 2,
                    "meta_whatsapp_template_status_name": "Approved",
                    "whatsapp_template_metadata_error_reason": null
                }
            }
        ]
    }
}

export const initialCustomVariableData = {
    chatbot_id: "",
    chatbot_custom_variable_name: "",
    chatbot_custom_variable_fallback_value: ""
}

export const updatedCustomVariableData = {
    chatbot_custom_variable_config_id: "",
    chatbot_custom_variable_name: "",
    chatbot_custom_variable_fallback_value: ""
}
export const chatbot_step_type_id_basic = "f9510824-ce88-4488-9297-5b6f9d41cdbc"
export const chatbot_step_type_id_webhook = "6d757849-6d46-442f-97c5-96d3572cde3a"

export const contentNodes = (currentActiveStaticWorkflow) => {
    
    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name?.toLowerCase();

    const isWhatsApp = isWhatsAppChannel(channelName);
    const isInstagram = isInstagramChannel(channelName);
    const isFacebook = isFacebookChannel(channelName);
    
    return [
        {
            id: "1",
            icon: <img src={ isWhatsApp ? whatsappIcon : isInstagram ? instagramIcon : isFacebook ? facebookIcon : whatsappIcon } style={{ width: "22px", height: "22px" }} alt="" />,
            style: { border: "2px dashed rgba(175, 175, 175, 0.5)", hover: "rgba(175, 175, 175, 0.1)" },
            name: "Send Message",
            type: "nodeWrapper",
            data: [],
            position: { x: 50, y: 50 },
            chatbot_step_type_id: chatbot_step_type_id_basic, 
            chatbot_step_exception: null,
        },
        ...(isWhatsApp ? [
            {
                id: "2",
                icon: <IconsColor iconName="webhookIcon" width="22px" height="22px" />,
                style: { border: "2px dashed rgba(175, 175, 175, 0.5)", hover: "rgba(175, 175, 175, 0.1)" },
                name: "Webhook",
                type: "nodeWrapper",
                data: [],
                position: { x: 50, y: 50 },
                chatbot_step_type_id: chatbot_step_type_id_webhook, 
                chatbot_step_exception: null,
            }
        ] : []),
    ]
}

export const getCustomVariableConditionText = (customVariableList, data) => {
    const variable = customVariableList?.custom_variable_data?.find((variable) => variable.chatbot_custom_variable_configuration_id == data?.chatbot_custom_variable_configuration_id)
    const variablename = variable?.chatbot_custom_variable_name || "";
    const operatorTypeName = data?.operator_type_name;
    const conditionValue = data?.condition_value;

    const rhsVariable = customVariableList?.custom_variable_data?.find((variable) => variable.chatbot_custom_variable_configuration_id == data?.rhs_chatbot_custom_variable_configuration_id)
    const rhsVariableName = rhsVariable?.chatbot_custom_variable_name || "";

    return `${variablename} ${operatorTypeName} ${rhsVariableName ? rhsVariableName : conditionValue}`;
}
export function getCurrentChannelMetaVariables(metaVariableList, currentActiveStaticWorkflow) {
    let currentChannelMetaVariables = metaVariableList.find((channel) => channel.channel_name.toLowerCase() == currentActiveStaticWorkflow?.chatbot_channel?.channel_name.toLowerCase())
    return currentChannelMetaVariables.metadata_type
}
export function getVariableOptionsBasedOnVariableType(customVariableList, metaVariableList, variableType, currentActiveStaticWorkflow) {
    let customVariables = customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
        chatbot_custom_variable_configuration_id: "-1",
        chatbot_custom_variable_name: "New Field",
        chatbot_custom_variable_fallback_value: "",
        flag_archived: false
    }] : [];
    let currentChannelMetaVariables = getCurrentChannelMetaVariables(metaVariableList, currentActiveStaticWorkflow)
    switch (variableType?.toLowerCase()) {
        case 'metadata':
            return currentChannelMetaVariables;
        default:
            return customVariables //custom
    }
}
export function getVariableLabelName(variableName) {
    switch (variableName?.toLowerCase()) {
        case 'metadata':
            return "metadata_type_name"
        default:
            return "chatbot_custom_variable_name"
    }
}
export function getVariableValue(customVariableList, metaVariableList, currentActiveStaticWorkflow, variable_type, chatbot_custom_variable_configuration_id, metadata_type_id) {
    let customVariableVal = customVariableList?.custom_variable_data?.find((variable) => variable.chatbot_custom_variable_configuration_id == chatbot_custom_variable_configuration_id)
    let currentChannelMetaVariables = getCurrentChannelMetaVariables(metaVariableList, currentActiveStaticWorkflow)
    let metaVariableVal = currentChannelMetaVariables?.find((metaVariable) => metaVariable.metadata_type_id == metadata_type_id)
    switch (variable_type?.toLowerCase()) {
        case 'metadata':
            return metaVariableVal || null
        default:
            return customVariableVal || null
    }
}

export function getVariableTypeValue(variableTypes, variable_type) {
    if (variable_type) {
        return variableTypes.find((variable) => variable.variable_type_name.toLowerCase() == variable_type.toLowerCase())
    }
    return variableTypes.find((variable) => variable.variable_type_name.toLowerCase() == "custom")
}
export function renderFieldsBasedonFieldType(fieldType, customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderOptions) {
    fieldType = fieldType?.toLowerCase()
    switch (fieldType) {
        case "custom":
            return {
                flagShowVariableMappingField: true,
                flagShowStaticValueField: false,
                fieldOptions: customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                    chatbot_custom_variable_configuration_id: "-1",
                    chatbot_custom_variable_name: "New Field",
                    chatbot_custom_variable_fallback_value: "",
                    flag_archived: false
                }] : [],
                fieldOptionKey: "chatbot_custom_variable_name",
                renderOption: renderOptions,
                listBoxProps: { style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }
            }
        case "static":
            return {
                flagShowVariableMappingField: false,
                flagShowStaticValueField: true,
                fieldOptions: [],
                fieldOptionKey: "",
                listBoxProps: undefined
            }
        case "metadata":
            return {
                flagShowVariableMappingField: true,
                flagShowStaticValueField: false,
                fieldOptions: metaDataVariableList ? metaDataVariableList.filter((channel) => channel.channel_name.toLowerCase() == currentActiveStaticWorkflow?.chatbot_channel?.channel_name.toLowerCase())[0]?.metadata_type ?? [] : [],
                fieldOptionKey: "metadata_type_name",
                renderOption: undefined,
                listBoxProps: undefined
            }
        default:
            return {
                flagShowVariableMappingField: null,
                flagShowStaticValueField: null,
                fieldOptions: [],
                fieldOptionKey: "",
                listBoxProps: undefined
            }
    }
}

export function getCurrentVariableType(variable, stepAction) {
    return (isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) ? stepAction.action_data.action_send_order_details_template_variable_data :  isCarouselTemplateActionType(stepAction?.action_type?.action_type_name) ? stepAction.action_data.action_send_dm_wa_carousel_template_variable_data : stepAction.action_data.action_send_dm_wa_template_variable_data)?.find((aData) => Number(aData.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.variable_type?.variable_type_name
}

export function getCurrentActiveNodeData(nodeId, nodes) {
    return nodes?.find((node) => node.id == nodeId) || null;
}

export const hours = Array.from({ length: 25 }, (_, i) => String(i));
export const minutes = ["0", "30"];

export const validateTime = (type, value, new_min, new_hour) => {
    if (type.toLowerCase() == "hour") {
        if (value == "0" && new_min == "0") {
            new_min = "30";
        } else if (value == "24" && new_min == "30") {
            new_min = "0";
        }
        new_hour = value;
    } else if (type.toLowerCase() == "min") {
        new_min = value;
    }
    return { new_min, new_hour }
}

export const isMinuteDisabled = (min, hour) => {
    if (hour == "0" && min == "0") return true;
    if (hour == "24" && min == "30") return true;
    return false;
};

export function extractKeyNameFromPath(path) {
    // Regular expression to match parts of the path such as ["keyname"] or [INDEX]
    const regex = /\["([^"]+)"\]|\[(\d+)\]/g;
    let matches;
    let lastKey = null;

    // Iterate through all matches in the path
    while ((matches = regex.exec(path)) !== null) {
        if (matches[1]) {
            // If the match is a key name (i.e., ["keyname"])
            lastKey = matches[1];
        } else if (matches[2]) {
            // If the match is an array index (i.e., [INDEX] or [0])
            lastKey = `[${matches[2]}]`; // return the index as the last "key" (e.g., [0], [1])
        }
    }

    // Return the last key found, or null if no key was found
    return lastKey;
} 

export const getInsideArrayFlagFromPath = (path) => {
    const regex = /\["(INDEX|\d+)"\]/;
    return regex.test(path);
} 

export const replaceNumberWithIndexInPath = (path) => {
    return path.replace(/\["\d+"\]/g, '[INDEX]'); // Replace json["test"]["5"]["username"] with json["test"][INDEX]["username"].
} 

export const getConfiguredWebhook = (configuredWebhookData, webhook_organization_id) => {
    if(configuredWebhookData){
        return configuredWebhookData?.find((webhook) => webhook.webhook_organization_id == webhook_organization_id);
    } 
    return null;
} 

export const isFlowTemplate = (currentActiveStaticWorkflow, template_id) => {
    if(currentActiveStaticWorkflow){
        const selectedTemplate = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => template?.whatsapp_template_id == template_id);
        if(selectedTemplate){
            return selectedTemplate?.whatsapp_template_flag_flow;
        }
    } 
    return false;
} 

export const isCatalogTemplate = (currentActiveStaticWorkflow, template_id) => {
    if(currentActiveStaticWorkflow){
        const selectedTemplate = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => template?.whatsapp_template_id == template_id);
        if(selectedTemplate){
            return selectedTemplate?.whatsapp_template_type?.name?.toLowerCase() === TEMPLATE_TYPES['CATALOG']?.toLowerCase();
        }
    } 
    return false;
}

export const isStartNode = (nodes, edges, stepId) => {
    const startNodeEdge = edges?.find((edge) => edge?.target == stepId && edge?.targetHandle == stepId)
    if(startNodeEdge){
        const startNode = nodes?.find((node) => node?.id == startNodeEdge?.source);
        if(startNode && startNode?.chatbot_step_name?.toLowerCase() == "trigger event"){
            return true;
        }
    } 
    return false;
}

export const getUpdatedValueOfNodesForCurrentActiveStaticWorkflow = (nodes, edges, chatbot_id) => {
    return nodes?.filter((node) => node?.chatbot_step_name?.toLowerCase() != "trigger event")?.map((node) => {
        return {
            chatbot_step_id: node?.id || "", 
            flag_start_node: isStartNode(nodes, edges, node?.id), 
            chatbot_step_name: node?.chatbot_step_name || "",
            chatbot_step_type: {
                chatbot_step_type_id: node?.chatbot_step_type_id, 
                chatbot_step_type_name: node?.chatbot_step_type_id == chatbot_step_type_id_basic ? "Regular" : "AwaitWebhook",
            }, 
            coordinates: {
                chatbot_step_x_axis: node?.position?.x || "", 
                chatbot_step_y_axis: node?.position?.y || "",
            }, 
            chatbot_step_exception: node?.chatbot_step_exception, 
            chatbot_step_flow: edges?.filter((edge) => edge?.target == node?.id && edge?.targetHandle == node?.id)?.map((edge) => {
                return {
                    chatbot_step_flow_id: edge?.id, 
                    chatbot_step_id: node?.id,
                    parent_chatbot_step_id: edge?.source, 
                    chatbot_id: chatbot_id, 
                    condition_group: edge?.condition_group ?? null,
                }
            }), 
            chatbot_step_action_data: node?.data?.filter((data) => !(data?.action_type?.action_type_name == "Custom_Variable_Condition")),
        }
    })
} 

export const handleHeaderDesignOfLeftSection = (mediaName) => {
    return getChatbotChannelTheme(mediaName).headerBg;
} 

export const handleLeftPanel = (setCurrentActiveNodeConfig) => {
    setCurrentActiveNodeConfig((prevState) => ({ ...prevState, flagOpenConfigForm: !prevState.flagOpenConfigForm, nodeId: null, data: [], flag_initial: false, flag_trigger: false }))
}

export const getChatbotStatusInfo = (selectedWorkflow) => {
    if(selectedWorkflow){ 
        const status = selectedWorkflow?.chatbot_status?.chatbot_status_name?.toLowerCase();
        switch(status){
            case "active": 
                return {
                    label: "Pause", 
                    icon:   <PauseIcon className={workflowStyle.chatbotStatusIconForMenu}  />,
                }
            case "paused":
                return {
                    label: "Active", 
                    icon:  <PlayArrowIcon className={workflowStyle.chatbotStatusIconForMenu}  />,
                } 
            default: 
                return {
                    label: "Pause", 
                    icon:  <PauseIcon className={workflowStyle.chatbotStatusIconForMenu}  />,
                }
        }
    }
    return {
        label: "Pause", 
        icon:  <PauseIcon className={workflowStyle.chatbotStatusIconForMenu}  />,
    }
} 

export const checkDisableTriggerKeywordsAndDefault = (triggerType, triggerKeywordsValue, defaultCheck) => {
    if(triggerType?.toLowerCase() == "keyword"){
        if(defaultCheck){
            return true;
        } else {
            return false;
        }
    } else {    
        if(triggerKeywordsValue && triggerKeywordsValue?.length > 0){
            return true;
        } else {
            return false;
        }
    }
}


export const isCurrentChatbotPublishedorPaused = (currentActiveStaticWorkflow) => {
    if(currentActiveStaticWorkflow?.chatbot_status?.chatbot_status_name?.toLowerCase() == "active" || currentActiveStaticWorkflow?.chatbot_status?.chatbot_status_name?.toLowerCase() == "paused"){
        return true;
    } 
    return false;
}

export const onClickOfQRCode = (phoneNumber, conditionGroup, setFlagShowQRCodePopup, setPhoneNumberQR, setConditionGroup, setQrChannelName, channelName = CHATBOT_CHANNEL_NAME.WHATSAPP) => {
    setFlagShowQRCodePopup(true);
    setPhoneNumberQR(phoneNumber);
    setConditionGroup(conditionGroup);
    setQrChannelName?.(channelName);
}

export const getOperatorTypeById = (operatorList, operator_type_id) => {
    return operatorList?.filter((operator) => operator.is_active).find((operator) => operator.operator_type_id == operator_type_id) ?? null;
}

export const getCustomVariableById = (customVariableList, chatbot_custom_variable_configuration_id) => {
    return customVariableList?.custom_variable_data?.find((variable) =>  chatbot_custom_variable_configuration_id == variable.chatbot_custom_variable_configuration_id);
}

export const getVariableToVariableValueText = (customVariableList, chatbot_custom_variable_configuration_id, source_chatbot_custom_variable_configuration_id, variable_static_value, type) => {

    const sourceVariableName = getCustomVariableById(customVariableList, source_chatbot_custom_variable_configuration_id)?.chatbot_custom_variable_name ?? "";
    const targetVariableName = getCustomVariableById(customVariableList, chatbot_custom_variable_configuration_id)?.chatbot_custom_variable_name ?? "";
    
    if(!chatbot_custom_variable_configuration_id && !source_chatbot_custom_variable_configuration_id && !variable_static_value){
        if(type?.toLowerCase() == "left section"){
            return "Please configure variable assignment";
        } else {
            return "Please Configure Variable Assignment*";
        }
    } else {
        if(!variable_static_value){
            return `${sourceVariableName} to ${targetVariableName}`;
        } else {
            return `Assign "${variable_static_value}" to ${targetVariableName}`;
        }
    }
}

export const isMediaHeaderInTemplate = (type) => {
    if(type?.toLowerCase() == "image" || type?.toLowerCase() == "video" || type?.toLowerCase() == "document"){
        return true;
    } 
    return false;
}

export const OPERATOR_TYPES = {
    IS_EMPTY: "is empty",
    IS_NOT_EMPTY: "is not empty",
    REGEX_MATCH: "regex match",
    CONTAINS_IN_ARRAY: "contains in array"
}
export const operatorTypesWithEmptyValue =  [OPERATOR_TYPES["IS_EMPTY"], OPERATOR_TYPES["IS_NOT_EMPTY"]];
export const operatorTypesBlockForVariableToVariable = [OPERATOR_TYPES["REGEX_MATCH"], OPERATOR_TYPES["CONTAINS_IN_ARRAY"]];

export const checkConditionValidation = (custom_variable_conditions) => {
    const hasVariableInCondition = custom_variable_conditions?.chatbot_custom_variable_configuration_id; 
    const hasOperatorTypeInCondition =  custom_variable_conditions?.operator_type_name?.toLowerCase() ?? ""; 
    const hasConditionValueInCondition = custom_variable_conditions?.condition_value?.trim();
    
    const isValueNotRequiredForOperator = operatorTypesWithEmptyValue.includes(hasOperatorTypeInCondition);
    const isOperatorTypeRegex = hasOperatorTypeInCondition == OPERATOR_TYPES["REGEX_MATCH"];

    if(isValueNotRequiredForOperator){
        if(!hasVariableInCondition || !hasOperatorTypeInCondition){
            return true; 
        }
        return false;
    }  

    if (isOperatorTypeRegex) {
        if (!hasVariableInCondition || !hasOperatorTypeInCondition || !hasConditionValueInCondition) {
            return true;
        }
        if (!checkValidRegex(hasConditionValueInCondition)) {
            return true;
        }
        return false;
    }

    const allFieldExist = hasVariableInCondition && hasOperatorTypeInCondition && hasConditionValueInCondition; 
    if(!allFieldExist){
        return true;
    }

    return false;
}

export const emptyNewVariableFieldObj = {
    chatbot_custom_variable_configuration_id: "-1",
    chatbot_custom_variable_name: "New Field",
    chatbot_custom_variable_fallback_value: "",
    flag_archived: false
}

export const emptyCustomVariableObj = {
    chatbot_custom_variable_configuration_id: null,
    chatbot_custom_variable_name: null,
    fallback_value: null
}

export const emptyCustomVariableConditionObj = {
    chatbot_custom_variable_configuration_id: "", 
    operator_type_id: "", 
    operator_type_name: "", 
    condition_value: "",
}

export const emptyConditionGroupObj = {
    condition_group_id: "",
    condition_group_name: "", 
    condition_type: "custom_variable", 
    flag_advanced_condition: false,
    custom_variable_conditions: emptyCustomVariableConditionObj
}

export const getDefaultValueOfIntentConfigurationPayload = (selectedIntent) => {
    if(selectedIntent){
        return selectedIntent;
    } else {
        return {
            intent_id: "", 
            intent_name: "", 
            condition_group: null,
            condition_group_id: null,
            flag_duplicate: false,
            flag_sum_of_siblings: false, 
            flag_remaining: false,
            chatbot_custom_variable_configuration_id: "",
            chatbot_custom_variable_name: "",
        }
    }
}

export const getDefaultValueOfTalkToAgentPayload = (actionData, isSourceHandleConnected) => {

    const condition_group = actionData?.condition_group;

    let updatedConditionGroup = null;
    let updatedConditionGroupId = null;

    if(condition_group){
        updatedConditionGroup = condition_group;
        updatedConditionGroupId = condition_group?.condition_group_id;
    } else if(isSourceHandleConnected) {
        updatedConditionGroup = emptyConditionGroupObj;
    }
    return {
        condition_group_id: updatedConditionGroupId,
        condition_group: updatedConditionGroup,
    }
}

export const getTalkToAgentDescriptionText = (customVariableList, condition_group, assignment_strategy_type) => {
    let descriptionTextInNode = "";
    let descriptionTextInLeftSection = "";
    if(assignment_strategy_type){
        if(condition_group){
            const conditionText = getCustomVariableConditionText(customVariableList, condition_group?.custom_variable_conditions);
            descriptionTextInNode = `if ${conditionText}`;
            descriptionTextInLeftSection = `Assign agent if ${conditionText}`;
        } else {
            const text = "Default assignment triggered.";
            descriptionTextInNode = text;
            descriptionTextInLeftSection = text;
        }
    } else {
        descriptionTextInNode = "Condition not set. Please configure it.";
        descriptionTextInLeftSection = "Condition not set. Click Edit to configure.";
    }

    return {
        descriptionTextInNode: descriptionTextInNode,
        descriptionTextInLeftSection: descriptionTextInLeftSection
    }
}


export const getRetrieveContactValueText = (actionData) => {
    if(actionData?.action_retrieve_contact_list_data?.length){
        return (
            <Grid container gap={1}>
                {actionData?.action_retrieve_contact_list_data?.map((list, index) => {
                    return (
                        <Grid item>
                            <a
                                href={`${window.location.origin}/contacts?contact_list_id=${list?.contact_list_id}`}
                                rel="noreferrer"
                                target='_blank'
                            >
                                {list?.contact_list_name}
                            </a>
                            {index < actionData?.action_retrieve_contact_list_data?.length - 1 ? ", " : ""}
                        </Grid>
                    );
                })}
            </Grid>
        )
    } else {
        return 'Please configure contact list';
    }
}

export const CHATBOT_VERSIONS = {
    DRAFT: "Draft",
    PUBLISHED: "Published"
}

export const setVersionsInTriggerConfigs = (triggers) => {
    let draftVersionIndex = triggers?.findIndex((trigers) => trigers?.chatbot_version_status_name?.toLowerCase() == CHATBOT_VERSIONS["DRAFT"].toLowerCase())
    if(draftVersionIndex == '-1'){
        let publishedVersion = triggers?.find((triggers) => triggers?.chatbot_version_status_name?.toLowerCase() == CHATBOT_VERSIONS["PUBLISHED"].toLowerCase())
        let draftVersion = JSON.parse(JSON.stringify(publishedVersion))
        draftVersion.chatbot_version_status_name = CHATBOT_VERSIONS["DRAFT"].toLowerCase()
        triggers?.push(draftVersion);
    }

    return triggers;
}

export const getCurrentViewVersionsTriggers = (chatbotTriggerConfigs, currentActiveStaticWorkflow) => {
    return chatbotTriggerConfigs?.find((config) => config?.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase());
} 
export const renderViewTemplateDetailsGridInNode = (messageTemplateDetail) => {
    return (
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
            <Grid item>
                <span className={templatePreviewStyles.templateNameInNodePreview}>
                    {messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_display_name ?? messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_name}
                </span>
            </Grid>
            <Tooltip title={"View Template in detail"}>
                {/* <Grid item onClick={(e) => { e.stopPropagation(); window.open(`${window.location.origin}/channels/viewintegration/whatsapp/legacy/templateinfo?id=${messageTemplateDetail?.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail?.whatsapp_template_id}`) }}> */}
                <Grid item 
                    // onClick={(e) => { 
                    //         e.stopPropagation(); 
                    //         isCarouselTemplate(messageTemplateDetail) 
                    //         ? window.open(`${window.location.origin}/channels/viewintegration/whatsapp/legacy/templateinfo?id=${messageTemplateDetail?.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail?.whatsapp_template_id}`, "_blank") 
                    //         : window.open(`${window.location.origin}/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${messageTemplateDetail?.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail?.whatsapp_template_id}`, "_blank") 
                    //     }}
                    // >
                    onClick={(e) => { 
                        e.stopPropagation(); 
                        window.open(`${window.location.origin}/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${messageTemplateDetail?.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail?.whatsapp_template_id}`, "_blank") 
                    }}
                >
                    <span className={templatePreviewStyles.openTemplateInNewTabIconSpan}>
                        <OpenInNewOutlinedIcon className={templatePreviewStyles.openTemplateInNewTabIcon} />
                    </span>
                </Grid>
            </Tooltip>
        </Grid>
    );
}

export const renderTemplateDetailsGridInNode = (messageTemplateDetail, currentActiveStaticWorkflow) => {
    return (
        <Grid item padding={1}>
            <Grid container gap={1}>
                <Grid item xs={12}>
                    {renderViewTemplateDetailsGridInNode(messageTemplateDetail)}
                </Grid>
                <Grid item xs={12}>
                    {renderTemplateCategoryChip(getTemplateDetailsUsedInNode(currentActiveStaticWorkflow, messageTemplateDetail?.whatsapp_template_id), true)}
                </Grid>
            </Grid>
        </Grid>
    );
}

export const getDefaultValueOfSendMediaPayload = (actionData) => {
    return {
        media_type: actionData?.media_type ?? null,
        google_storage_id: actionData?.google_storage_id ?? null,
        caption: actionData?.caption ?? "",
        file_mime_type: actionData?.file_mime_type ?? null,
    }
}

export const doesAllowToConfigureIntentForActionType = (actionType) => {

    const allowedActionType = [
        ACTION_TYPE_NAME["TEXT"],
        INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"],
        ACTION_TYPE_NAME["TEMPLATE"],
        ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"],
        ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"],
        ACTION_TYPE_NAME["SAVE_DATA"],
        ACTION_TYPE_NAME["RESET_DATA"],
        ACTION_TYPE_NAME["CUSTOM_API"],
        ACTION_TYPE_NAME["SEND_MEDIA"],
        ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"],
        ACTION_TYPE_NAME["SAVE_CONTACT"],
        ACTION_TYPE_NAME["REMOVE_CONTACT"],
        ACTION_TYPE_NAME["TALK_TO_AGENT"],
        ACTION_TYPE_NAME["ASSIGN_TAG"],
        ACTION_TYPE_NAME["REMOVE_TAG"],
        ACTION_TYPE_NAME["ARCHIVE_CHAT"],
        ACTION_TYPE_NAME["RETRIEVE_CONTACT"]
    ]
    if(allowedActionType?.includes(actionType ?? "")){
        return true;
    } 
    return false;
}


export const getActionTypeObj = (title, description, actionType, icon, maxLength, allowedStepId) => {
    return {
        title: title,
        description: description,
        actionType: actionType,
        icon: icon,
        maxLength: maxLength,
        allowedStepId: allowedStepId
    }
}

export const actionTypes = (currentActiveStaticWorkflow) => { 

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name?.toLowerCase() ?? "";

    const isWhatsApp = isWhatsAppChannel(channelName);
    const isInstagram = isInstagramChannel(channelName);

    return [
        ...((isWhatsApp || isInstagram) ? [
            getActionTypeObj("Text", "Add Simple text", (isWhatsApp ? ACTION_TYPE_NAME["TEXT"] : INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]), "textComponent", undefined, [chatbot_step_type_id_basic]),
        ] : []),

        ...(isWhatsApp ? [
            getActionTypeObj("Template", "Add interactive templates", ACTION_TYPE_NAME["TEMPLATE"], "templatemessage", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Carousel Template", "Add carousel template", ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"], "carouselTemplate", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Send Order Detail Template", "Add Send Order Detail template", ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"], "sendOrderDetailTemplate", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Media", "Add Media", ACTION_TYPE_NAME["SEND_MEDIA"], "sendMediaAction", undefined, [chatbot_step_type_id_basic]),
        ] : []),

        ...((isWhatsApp || isInstagram) ? [
            getActionTypeObj("Save Data", "Collect emails, phones and more", ACTION_TYPE_NAME["SAVE_DATA"], "dataCollectionComponent", 1, [chatbot_step_type_id_basic]),
        ] : []),

        ...(isWhatsApp ? [
            getActionTypeObj("Variable Assignment", "Assign value to variable", ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"], "saveVariableToVariable", 1, [chatbot_step_type_id_basic]),
        ] : []),
        
        ...((isWhatsApp || isInstagram) ? [
            getActionTypeObj("Reset Data", "Reset emails, phones and more", ACTION_TYPE_NAME["RESET_DATA"], "resetData", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Archive Chat", "Archive Conversation", ACTION_TYPE_NAME["ARCHIVE_CHAT"], "archiveThreadAction", 1, [chatbot_step_type_id_basic]),
        ] : []),
        
        ...(isWhatsApp ? [
            getActionTypeObj("Save Contact", "Save contact in contact list", ACTION_TYPE_NAME["SAVE_CONTACT"], "saveContactAction", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Remove Contact", "Remove contact from contact list", ACTION_TYPE_NAME["REMOVE_CONTACT"], "removeContactAction", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Retrieve Contact", "Retrieve contact data from contact list", ACTION_TYPE_NAME["RETRIEVE_CONTACT"], "retrieveContact", 1, [chatbot_step_type_id_basic]),
        ] : []),
        
        ...((isWhatsApp || isInstagram) ? [
            getActionTypeObj("Assign Tag", "Assign tag to conversation", ACTION_TYPE_NAME["ASSIGN_TAG"], "assignTagAction", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Remove Tag", "Remove tag from conversation", ACTION_TYPE_NAME["REMOVE_TAG"], "removeTagAction", 1, [chatbot_step_type_id_basic]),
        ] : []),
        
        ...(isWhatsApp ? [
            getActionTypeObj("Assign Agent", "Randomly assign an agent", ACTION_TYPE_NAME["TALK_TO_AGENT"], "talkToAgentAction", 1, [chatbot_step_type_id_basic]),
        ] : []),

        ...((isWhatsApp || isInstagram) ? [
            getActionTypeObj("Custom API", "Trigger real-time actions with our Custom API integration", ACTION_TYPE_NAME["CUSTOM_API"], "custom_api", 1, [chatbot_step_type_id_basic]),
            getActionTypeObj("Condition", "Route users based on specific rules or data values.", ACTION_TYPE_NAME["CONDITION"], "conditionIcon", 10, [chatbot_step_type_id_basic]),
        ] : []),

        ...(isWhatsApp ? [
            getActionTypeObj("Await Webhook", "Configure Webhook", ACTION_TYPE_NAME["AWAIT_WEBHOOK"], "webhookIcon", 1, [chatbot_step_type_id_webhook])
        ] : []),
    ]
}
// future blocks
// {
//     title:"Image",
//     description:"Boost engagement with visuals",
//     actionType:"send_image",
//       icon: 'imageComponent'
// },
// {
//     title:"Delay",
//     description:"Wait a few seconds in between texts",
//     actionType:"delay",
//       icon: 'delayComponent'
// },
// {
//     title:"More",
//     description:"View all available options",
//     actionType:"delay",
//       icon: 'viewMoreComponent'
// },

export const emptyContactListObj = {
    contact_list_id: -1,
    contact_list_name: "New List",
    total_contact: 0,
    created_at_timestamp: "",
    updated_at_timestamp: "",
    contact_list_status_id: -1,
    contact_list_status_name: "",
}

export const ASSIGNMENT_STRATEGY_TYPE = {
    RANDOM: "random"
}

export const isAssignmentStrategyTypeRandom = (name) => {
    return name?.toLowerCase() == ASSIGNMENT_STRATEGY_TYPE["RANDOM"]?.toLowerCase();
}

export const checkIfMediaIsSavedInBE = (flag_saved_in_BE, action_data) => {
    if(flag_saved_in_BE || (action_data?.media_type?.media_type_id && action_data?.file_mime_type?.file_mime_type_id && action_data?.google_storage_id)){
        return true;
    }

    return false;
}

export const getMediaFileDescription = (flag_saved_in_BE, action_data, section) => {
    let description = "";
    if(checkIfMediaIsSavedInBE(flag_saved_in_BE, action_data)){
        description = toCapitalizedCase(action_data?.media_type?.media_type_name);
    } else {
        const text = "Select media"; 
        if(section?.toLowerCase() == "node"){
            description = `${text}*`;
        } else {
           description = text;
        } 
    }

    return {
        title: "Media",
        description: description,
    }
}

export const getDelayTimeOptionObj = (label, value) => {
    return {
        label: label,
        value: value
    }
}

const MILLISECONDS_PER_MINUTE = 60 * 1000;
const MILLISECONDS_PER_HOUR = 60 * MILLISECONDS_PER_MINUTE;

const options = [
    ["2 Minutes", 2 * MILLISECONDS_PER_MINUTE],
    ["10 Minutes", 10 * MILLISECONDS_PER_MINUTE],
    ["30 Minutes", 30 * MILLISECONDS_PER_MINUTE],
    ["1 Hour", 1 * MILLISECONDS_PER_HOUR],
    ["5 Hours", 5 * MILLISECONDS_PER_HOUR],
    ["10 Hours", 10 * MILLISECONDS_PER_HOUR],
    ["24 Hours", 24 * MILLISECONDS_PER_HOUR],
];

export const delayTimeOptions = options.map(([label, value]) => ({ label, value }));

export const getDelayObjByValue = (value) => {
    return delayTimeOptions?.find((time) => time?.value == value) ?? null;
}

export const hasTalkToAgentAction = (data) => {
    return data?.find((action) => action?.action_type?.action_type_name == ACTION_TYPE_NAME["TALK_TO_AGENT"]) || null;
}

export const hasArchiveChatAction = (data) => {
    return data?.find((action) => action?.action_type?.action_type_name == ACTION_TYPE_NAME["ARCHIVE_CHAT"]) || null;
}

export const getActionTypeId = (chatbotActionTypeData, actionTypeName) => {
    const actionType = chatbotActionTypeData?.find((action) => action?.action_type_name?.toLowerCase() == actionTypeName?.toLowerCase());

    return actionType?.action_type_id ?? '';
}

export const isSendOrderPaymentInfoSystemAPIExist = (nodes, nodeId, currentActiveStaticWorkflow) => {
    const isCustomAPIExist = nodes?.find((node) => node?.id == nodeId)?.data?.find((data) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['CUSTOM_API']);
    if(isCustomAPIExist){
        const customAPIDetails = currentActiveStaticWorkflow?.additional_data?.data_connectors?.find((dataConnector) => String(dataConnector?.chatbot_data_connector_id) == String(isCustomAPIExist?.action_data?.data_connector?.chatbot_data_connector_id));
        if(customAPIDetails && !customAPIDetails?.function_method_name && customAPIDetails?.data_connector_functions?.data_connector_function_name?.toLowerCase() === WHATSAPP_PAYMENT_INFO_SYSTEM_API?.toLowerCase()){
            return true;
        }
    }
    return false;
}

export const createNewCustomAPIObj = {
    chatbot_data_connector_id: -1,
    chatbot_data_connector_url: "",
    chatbot_data_connector_function_path: null,
    function_method_id: -1,
    function_method_name: "",
    data_connector_assignment: [],
    data_connector_platform_assignment: [],
    data_connector_functions: {
        data_connector_function_id: -1,
        data_connector_function_name: "Create New Custom API",
        data_connector_asst_function_name: "",
        data_connector_function_description: "",
    },
    last_updated_at_timestamp: '',
    flag_allow_voice_agent_assignment: false
}

export const renderCustomAPIOptions = (props, option) => {
    return (
        <RenderCustomOption
            autocompleteRenderOptionProps={props} 
            option={option} 
            customOptionName={"New Custom API"} 
            optionName={option['data_connector_functions']['data_connector_function_name']} 
            optionLabelKey={'chatbot_data_connector_id'} 
            onClickOfCustomOption={() => window.open('/customAPI/createCustomAPI', '_blank')} 
            flagRenderCustomOption
            renderCustomOption={(option) => {
                return <li>
                    <Grid container gap="15px" flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item boxShadow={`0px 0px 2px ${fontColorForMethod(option?.function_method_name)}`} padding={"1px 6px"} borderRadius={"5px"} color={fontColorForMethod(option?.function_method_name)} fontSize={"14px"} minWidth={"60px"} textAlign={"center"}>
                            {option?.function_method_name ?? 'System API'}
                        </Grid>
                        <Grid item className={`${globalStyles.secondaryFontSize}`}>
                            {option?.data_connector_functions?.data_connector_function_name}
                        </Grid>
                    </Grid>
                </li>
            }}
        />
    );
}